import React, { useEffect, useState, useContext } from 'react'
import Bounce from 'react-activity/dist/Bounce'
import 'react-activity/dist/Bounce.css'
import '../styles/settings.css'
import '@dsalvagni/react-profile-picture/dist/ProfilePicture.css'
import { BsKey, BsEyeSlash, BsExclamationCircle } from 'react-icons/bs'
import { useParams } from 'react-router-dom'
import AuthLayout from '../layouts/AuthLayout'
import { AuthContext } from '../contexts/AuthContext'

export default function ResetPassword() {
  const { token } = useParams()
  const [newpassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')
  const [error, setError] = useState('')
  const [isFormChanged, setIsFormChanged] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const { resetpassword, isLoading } = useContext(AuthContext)

  useEffect(() => {
    if (newpassword !== '' && confirmNewPassword !== '') {
      setIsFormChanged(true)
    } else {
      setIsFormChanged(false)
    }
  }, [newpassword, confirmNewPassword])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (isLoading === false) {
      try {
        if (newpassword !== '' && confirmNewPassword !== '') {
          if (newpassword.length < 6 || confirmNewPassword.length < 6) {
            setError('Password must have at least 6 characters')
            return
          } else if (newpassword !== confirmNewPassword) {
            setError("Passwords don't match")
            return
          } else {
            setError('')
            const response = await resetpassword(
              token,
              newpassword,
              confirmNewPassword,
            )
            if (response === 'success') {
              setNewPassword('')
              setConfirmNewPassword('')
            }
          }
        } else {
          setError('All fields are required')
          return
        }
      } catch (error) {
        setError('Update failed: ' + error)
      }
    }
  }

  return (
    <AuthLayout pageName={'Reset Password'}>
      <form onSubmit={handleSubmit}>
        <h3 className='heading'>Reset Password</h3>
        <h6>Please enter your new password below</h6>
        <hr className='bg-light' />

        <div className='form-group !mt-0'>
          <label htmlFor='newpassword'>New Password</label>
          <div
            className='input-icon cursor-pointer'
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <BsKey size={20} /> : <BsEyeSlash size={20} />}
          </div>
          <input
            type={showPassword ? 'text' : 'password'}
            id='oldpassword'
            value={newpassword}
            className='form-control'
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        <div
          className='flex items-center p-4 text-neutral-500 border-t-4 border-neutral-200 bg-neutral-100 mb-2'
          role='alert'
        >
          <svg
            className='flex-shrink-0 w-4 h-4'
            aria-hidden='true'
            xmlns='http://www.w3.org/2000/svg'
            fill='currentColor'
            viewBox='0 0 20 20'
          >
            <path d='M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z' />
          </svg>
          <div className='ms-3 text-sm font-medium'>
            The new password must be at least 6 characters long
          </div>
        </div>
        <div className='form-group'>
          <label htmlFor='confirmNewPassword'>Confirm New Password</label>
          <div
            className='input-icon cursor-pointer'
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? (
              <BsKey size={20} />
            ) : (
              <BsEyeSlash size={20} />
            )}
          </div>
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            id='newpassword'
            value={confirmNewPassword}
            className='form-control'
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            required
          />
        </div>
        {error !== '' ? (
          <div className='flex items-center gap-2 text-left text-red-500 text-md my-3'>
            <BsExclamationCircle size={16} /> {error}
          </div>
        ) : (
          <div className='my-3'></div>
        )}
        <div>
          <button
            type='submit'
            className='btn-submit w-full text-center justify-center !py-4'
            disabled={isLoading || !isFormChanged}
          >
            {isLoading === false ? (
              'Reset Password'
            ) : (
              <Bounce
                className='py-[7px]'
                animating={isLoading}
              />
            )}
          </button>
        </div>
      </form>
    </AuthLayout>
  )
}
